<template>
    <div class="p-2 font-weight-bold" :class="{ 'text-muted': disabled == 'true' }">
        <b-icon :icon="icon"></b-icon>
        <span class="p-4">{{name}}</span>
    </div>
</template>

<style scoped>

</style>

<script>
export default {
    props: {
        icon: String,
        name: String,
        disabled: String
    }
}
</script>